export const PRESS_OUTREACH_REPLIES_QUERY_KEY = [
  'admin',
  'press-outreach-replies',
] as const;

const STORAGE_KEY = 'cp.admin.press_outreach.replies_last_opened_at';

export const PRESS_OUTREACH_REPLIES_OPENED_EVENT =
  'press-outreach-replies-opened';

export type PressOutreachReplyForUnread = {
  received_at: string | null;
};

export function getPressOutreachRepliesLastOpenedAt(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(STORAGE_KEY);
}

export function setPressOutreachRepliesLastOpenedAt(
  at: string = new Date().toISOString(),
): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, at);
  window.dispatchEvent(
    new CustomEvent(PRESS_OUTREACH_REPLIES_OPENED_EVENT, { detail: at }),
  );
}

export function countUnreadPressOutreachReplies(
  replies: PressOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): number {
  if (!replies.length) {
    return 0;
  }

  const openedMs = lastOpenedAt ? Date.parse(lastOpenedAt) : Number.NaN;
  const hasValidOpenedAt = lastOpenedAt !== null && !Number.isNaN(openedMs);

  return replies.filter((reply) => {
    if (!reply.received_at) {
      return false;
    }
    const receivedMs = Date.parse(reply.received_at);
    if (Number.isNaN(receivedMs)) {
      return false;
    }
    if (!hasValidOpenedAt) {
      return true;
    }
    return receivedMs > openedMs;
  }).length;
}

export function hasUnreadPressOutreachReplies(
  replies: PressOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): boolean {
  return countUnreadPressOutreachReplies(replies, lastOpenedAt) > 0;
}
